<template>
  <div>
      <el-dialog :visible.sync="showPopup" :title="raspuns.length > 0 ? 'Produse deviz #' + raspuns[0].IdDeviz : 'Nu exista produse pe acest deviz.'" width="80%" >
        <span v-if="this.raspuns.length > 0">Tip auto: {{raspuns[0].TipAuto}}</span>

        <el-table  v-if="this.raspuns.length > 0"  :data="raspuns">
          <el-table-column prop="Nume" label="Nume" width="400px"></el-table-column>
          <el-table-column prop="Pret" label="Pret" align="right"></el-table-column>
          <el-table-column prop="Cantitate" label="Cantitate" align="right"></el-table-column>
          <el-table-column prop="Valoare" label="Valoare" align="right"></el-table-column>
        </el-table>
        <div class="total">
          <strong> <span v-if="this.raspuns.length > 0">Total: {{raspuns[0].Total}}</span> </strong>
        </div>
        <span slot="footer" class="dialog-footer" >
          <el-button @click="showPopup = false" > Inchide </el-button>
        </span>  
      </el-dialog>
  </div>
</template>
 
<script>
import moment from 'moment';
import BasePage from "@/pages/Admin/BasePage";

export default {
  name: "Preview_deviz",
  extends: BasePage,
  data() {
    return {
      raspuns: [{TipAuto:'', Total:''}],
      showPopup: false,
      mode: 'view',
    };
  },
  methods: {
    async show(deviz, modifica = null){
      if(modifica) this.mode = 'add';
      this.showPopup = true
      await this.get_info(deviz);
      },
    async get_info(deviz){
      let rezultat = await this.post("service/devize/get_produse_deviz", {idDeviz: deviz});
      // console.log(rezultat);
      this.raspuns = rezultat.deviz;
    },
  },
  async mounted() {
   
  },

};
</script>

<style scoped>

  .total {
    width: 100%;
    margin-top: 10px;
    text-align: end;
    font-size: 23px;
  }

</style>